
// New component for metric cards
const MetricCard = ({ title, value, icon, trend, change, color }) => {
  const trendColor = trend === 'up' ? 'text-green-500' : 'text-red-500';
  const bgColor = `bg-${color}-100`;
  const textColor = `text-${color}-600`;
  
  return (
    <div className={`${bgColor} ${textColor} p-4 rounded-lg shadow-md flex flex-col`}>
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium">{title}</p>
          <p className="text-2xl font-bold mt-1">{value}</p>
        </div>
        <div className={`p-2 rounded-full ${bgColor}`}>
          {icon}
        </div>
      </div>
      {change && (
        <div className="mt-2 flex items-center">
          <span className={`${trendColor} text-sm font-medium`}>
            {change} {trend === 'up' ? '↑' : '↓'}
          </span>
          <span className="text-xs text-gray-500 ml-1">vs previous period</span>
        </div>
      )}
    </div>
  );
};


export default MetricCard;